/**
 * Result from running the `IntrospectionQuery` against our entire (server + client) GraphQL schema.
 *
 * This object is often used by internal tool. It allows us to dynamically query
 * properties about our GraphQL schema. An example usage is to find all the nodes
 * in our schema. (getAllNodeNamesInSchema.ts)
 */
import {getIntrospectionQuery, graphqlSync, IntrospectionQuery} from 'graphql';

import GraphQLSchema from 'graphql-client/schema/GraphQLSchema';

const GraphQLIntrospectionResult = graphqlSync({schema: GraphQLSchema, source: getIntrospectionQuery()})
  .data! as unknown as IntrospectionQuery;

export default GraphQLIntrospectionResult;
